var items = {
  "block.minecraft.air": "ваздух",
  "block.minecraft.stone": "камен",
  "block.minecraft.granite": "гранит",
  "block.minecraft.polished_granite": "полирани гранит",
  "block.minecraft.diorite": "диорит",
  "block.minecraft.polished_diorite": "полирани диорит",
  "block.minecraft.andesite": "андезит",
  "block.minecraft.polished_andesite": "полирани андезит",
  "block.minecraft.grass_block": "блок траве",
  "block.minecraft.dirt": "земља",
  "block.minecraft.coarse_dirt": "храпава земља",
  "block.minecraft.podzol": "подзол",
  "block.minecraft.crimson_nylium": "гримизни нилијум",
  "block.minecraft.warped_nylium": "изопачени нилијум",
  "block.minecraft.cobblestone": "калдрма",
  "block.minecraft.oak_planks": "даске од храстовине",
  "block.minecraft.spruce_planks": "даске од смреке",
  "block.minecraft.birch_planks": "даске од брезе",
  "block.minecraft.jungle_planks": "даске од дрвета из џунгле",
  "block.minecraft.acacia_planks": "багремове даске",
  "block.minecraft.dark_oak_planks": "даске од тамног храста",
  "block.minecraft.crimson_planks": "гримизне даске",
  "block.minecraft.warped_planks": "изопачене даске",
  "block.minecraft.oak_sapling": "младица храста",
  "block.minecraft.spruce_sapling": "младица смреке",
  "block.minecraft.birch_sapling": "младица брезе",
  "block.minecraft.jungle_sapling": "младица дрвета из џунгле",
  "block.minecraft.acacia_sapling": "младица багрема",
  "block.minecraft.dark_oak_sapling": "младица тамног храста",
  "block.minecraft.bedrock": "темељац",
  "block.minecraft.sand": "песак",
  "block.minecraft.red_sand": "црвени песак",
  "block.minecraft.gravel": "шљунак",
  "block.minecraft.gold_ore": "руда злата",
  "block.minecraft.iron_ore": "руда гвожђа",
  "block.minecraft.coal_ore": "руда угља",
  "block.minecraft.nether_gold_ore": "руда недер злата",
  "block.minecraft.oak_log": "храстовина",
  "block.minecraft.spruce_log": "смрека",
  "block.minecraft.birch_log": "брезовина",
  "block.minecraft.jungle_log": "дрво џунгле",
  "block.minecraft.acacia_log": "дрво багрема",
  "block.minecraft.dark_oak_log": "тамно храстово дрво",
  "block.minecraft.crimson_stem": "гримизна стабљика",
  "block.minecraft.warped_stem": "изопачена стабљика",
  "block.minecraft.stripped_oak_log": "огуљени храст",
  "block.minecraft.stripped_spruce_log": "огуљена смрека",
  "block.minecraft.stripped_birch_log": "огуљена бреза",
  "block.minecraft.stripped_jungle_log": "огуљено дрво џунгле",
  "block.minecraft.stripped_acacia_log": "огуљена акација",
  "block.minecraft.stripped_dark_oak_log": "огуљени тамни храст",
  "block.minecraft.stripped_crimson_stem": "огуљена гримизна стабљика",
  "block.minecraft.stripped_warped_stem": "огуљена изопачена стабљика",
  "block.minecraft.stripped_oak_wood": "огуљена храстовина",
  "block.minecraft.stripped_spruce_wood": "огуљено дрво смреке",
  "block.minecraft.stripped_birch_wood": "огуљена брезовина",
  "block.minecraft.stripped_jungle_wood": "огуљено дрво џунгле",
  "block.minecraft.stripped_acacia_wood": "огуљено дрво багрема",
  "block.minecraft.stripped_dark_oak_wood": "огуљено тамно храстово дрво",
  "block.minecraft.stripped_crimson_hyphae": "огуљена гримизна хифа",
  "block.minecraft.stripped_warped_hyphae": "огуљена изопачена хифа",
  "block.minecraft.oak_wood": "храстовина",
  "block.minecraft.spruce_wood": "дрво смреке",
  "block.minecraft.birch_wood": "брезовина",
  "block.minecraft.jungle_wood": "дрво џунгле",
  "block.minecraft.acacia_wood": "дрво багрема",
  "block.minecraft.dark_oak_wood": "тамно храстово дрво",
  "block.minecraft.crimson_hyphae": "гримизна хифа",
  "block.minecraft.warped_hyphae": "изопачена хифа",
  "block.minecraft.oak_leaves": "лишће храста",
  "block.minecraft.spruce_leaves": "лишће смреке",
  "block.minecraft.birch_leaves": "лишће брезе",
  "block.minecraft.jungle_leaves": "лишће из џунгле",
  "block.minecraft.acacia_leaves": "лишће акације",
  "block.minecraft.dark_oak_leaves": "лишће тамног храста",
  "block.minecraft.sponge": "сунђер",
  "block.minecraft.wet_sponge": "мокар сунђер",
  "block.minecraft.glass": "стакло",
  "block.minecraft.lapis_ore": "руда лапис лазулија",
  "block.minecraft.lapis_block": "блок лапис лазулија",
  "block.minecraft.dispenser": "аутомат",
  "block.minecraft.sandstone": "пешчар",
  "block.minecraft.chiseled_sandstone": "исклесани пешчар",
  "block.minecraft.cut_sandstone": "сечени пешчар",
  "block.minecraft.note_block": "музички блок",
  "block.minecraft.powered_rail": "пруга под напоном",
  "block.minecraft.detector_rail": "сензор шина",
  "block.minecraft.sticky_piston": "лепљиви клип",
  "block.minecraft.cobweb": "паучина",
  "block.minecraft.grass": "трава",
  "block.minecraft.fern": "папрат",
  "block.minecraft.dead_bush": "увенули жбун",
  "block.minecraft.seagrass": "морска трава",
  "block.minecraft.sea_pickle": "морски краставац",
  "block.minecraft.piston": "клип",
  "block.minecraft.white_wool": "бела вуна",
  "block.minecraft.orange_wool": "наранџаста вуна",
  "block.minecraft.magenta_wool": "магента вуна",
  "block.minecraft.light_blue_wool": "светло плава вуна",
  "block.minecraft.yellow_wool": "жута вуна",
  "block.minecraft.lime_wool": "светло зелена вуна",
  "block.minecraft.pink_wool": "розе вуна",
  "block.minecraft.gray_wool": "сива вуна",
  "block.minecraft.light_gray_wool": "светлосива вуна",
  "block.minecraft.cyan_wool": "цијан вуна",
  "block.minecraft.purple_wool": "љубичаста вуна",
  "block.minecraft.blue_wool": "плава вуна",
  "block.minecraft.brown_wool": "браон вуна",
  "block.minecraft.green_wool": "зелена вуна",
  "block.minecraft.red_wool": "црвена вуна",
  "block.minecraft.black_wool": "црна вуна",
  "block.minecraft.dandelion": "маслачак",
  "block.minecraft.poppy": "мак",
  "block.minecraft.blue_orchid": "плава oрхидеја",
  "block.minecraft.allium": "лук",
  "block.minecraft.azure_bluet": "плава хустонија",
  "block.minecraft.red_tulip": "црвена лала",
  "block.minecraft.orange_tulip": "наранџаста лала",
  "block.minecraft.white_tulip": "бела лала",
  "block.minecraft.pink_tulip": "розе лала",
  "block.minecraft.oxeye_daisy": "бела рада",
  "block.minecraft.cornflower": "различак",
  "block.minecraft.lily_of_the_valley": "ђурђевак",
  "block.minecraft.wither_rose": "видер ружа",
  "block.minecraft.brown_mushroom": "браон печурка",
  "block.minecraft.red_mushroom": "црвена печурка",
  "block.minecraft.crimson_fungus": "гримизна гљива",
  "block.minecraft.warped_fungus": "изопачена гљива",
  "block.minecraft.crimson_roots": "гримизно корење",
  "block.minecraft.warped_roots": "изопачено корење",
  "block.minecraft.nether_sprouts": "недер клице",
  "block.minecraft.weeping_vines": "јецајуће лијане",
  "block.minecraft.twisting_vines": "уврнуте лијане",
  "block.minecraft.sugar_cane": "шећерна трска",
  "block.minecraft.kelp": "келп",
  "block.minecraft.bamboo": "бамбус",
  "block.minecraft.gold_block": "златни блок",
  "block.minecraft.iron_block": "гвоздени блок",
  "block.minecraft.oak_slab": "храстова плоча",
  "block.minecraft.spruce_slab": "плоча од смреке",
  "block.minecraft.birch_slab": "плоча од брезе",
  "block.minecraft.jungle_slab": "плоча од дрвета из џунгле",
  "block.minecraft.acacia_slab": "плоча багрема",
  "block.minecraft.dark_oak_slab": "плоча тамног храста",
  "block.minecraft.crimson_slab": "гримизна плоча",
  "block.minecraft.warped_slab": "изопачена плоча",
  "block.minecraft.stone_slab": "камени степеник",
  "block.minecraft.smooth_stone_slab": "глатка камена плоча",
  "block.minecraft.sandstone_slab": "пешчарска плоча",
  "block.minecraft.cut_sandstone_slab": "плоча сеченог пешчара",
  "block.minecraft.petrified_oak_slab": "окамењена храстова плоча",
  "block.minecraft.cobblestone_slab": "плоча од калдрме",
  "block.minecraft.brick_slab": "циглена плоча",
  "block.minecraft.stone_brick_slab": "плоча од камених цигала",
  "block.minecraft.nether_brick_slab": "недер циглена плоча",
  "block.minecraft.quartz_slab": "плочник од кварца",
  "block.minecraft.red_sandstone_slab": "плоча црвеног пешчара",
  "block.minecraft.cut_red_sandstone_slab": "плоча црвеног сеченог пешчара",
  "block.minecraft.purpur_slab": "пурпур плоча",
  "block.minecraft.prismarine_slab": "плоча призмарина",
  "block.minecraft.prismarine_brick_slab": "плоча призмаринске цигле",
  "block.minecraft.dark_prismarine_slab": "тамна плоча призмарина",
  "block.minecraft.smooth_quartz": "гладак блок кварца",
  "block.minecraft.smooth_red_sandstone": "гладак црвени пешкар",
  "block.minecraft.smooth_sandstone": "гладак пешчар",
  "block.minecraft.smooth_stone": "гладак камен",
  "block.minecraft.bricks": "цигле",
  "block.minecraft.tnt": "динамит",
  "block.minecraft.bookshelf": "полица за књиге",
  "block.minecraft.mossy_cobblestone": "калдрма са маховином",
  "block.minecraft.obsidian": "обсидијан",
  "block.minecraft.torch": "бакља",
  "block.minecraft.end_rod": "енд штап",
  "block.minecraft.chorus_plant": "хорус",
  "block.minecraft.chorus_flower": "хорус цвет",
  "block.minecraft.purpur_block": "пурпурни блок",
  "block.minecraft.purpur_pillar": "пурпурни стуб",
  "block.minecraft.purpur_stairs": "пурпурне степенице",
  "block.minecraft.spawner": "стварач",
  "block.minecraft.oak_stairs": "храстове степенице",
  "block.minecraft.chest": "ковчег",
  "block.minecraft.diamond_ore": "руда дијаманта",
  "block.minecraft.diamond_block": "дијамантски блок",
  "block.minecraft.crafting_table": "занатски сто",
  "block.minecraft.farmland": "ораница",
  "block.minecraft.furnace": "пећница",
  "block.minecraft.ladder": "мердевине",
  "block.minecraft.rail": "пруга",
  "block.minecraft.cobblestone_stairs": "степенице од калдрме",
  "block.minecraft.lever": "полуга",
  "block.minecraft.stone_pressure_plate": "камена потисна плоча",
  "block.minecraft.oak_pressure_plate": "потисна плоча тамног храста",
  "block.minecraft.spruce_pressure_plate": "потисна плоча од смреке",
  "block.minecraft.birch_pressure_plate": "потисна плоча од брезе",
  "block.minecraft.jungle_pressure_plate": "потисна плоча дрвета џунгле",
  "block.minecraft.acacia_pressure_plate": "потисна плоча багрема",
  "block.minecraft.dark_oak_pressure_plate": "потисна плоча тамног храста",
  "block.minecraft.crimson_pressure_plate": "гримизна потисна плоча",
  "block.minecraft.warped_pressure_plate": "изопачена потисна плоча",
  "block.minecraft.polished_blackstone_pressure_plate": "потисна плоча од полиране црне калдрме",
  "block.minecraft.redstone_ore": "редстоун руда",
  "block.minecraft.redstone_torch": "редстоун бакља",
  "block.minecraft.snow": "снег",
  "block.minecraft.ice": "лед",
  "block.minecraft.snow_block": "снежни блок",
  "block.minecraft.cactus": "кактус",
  "block.minecraft.clay": "глина",
  "block.minecraft.jukebox": "џубокс",
  "block.minecraft.oak_fence": "ограда од храста",
  "block.minecraft.spruce_fence": "ограда од смреке",
  "block.minecraft.birch_fence": "ограда од брезе",
  "block.minecraft.jungle_fence": "ограда од дрвета џунгле",
  "block.minecraft.acacia_fence": "ограда од багрема",
  "block.minecraft.dark_oak_fence": "ограда од тамног храста",
  "block.minecraft.crimson_fence": "гримизна ограда",
  "block.minecraft.warped_fence": "изопачена ограда",
  "block.minecraft.pumpkin": "бундева",
  "block.minecraft.carved_pumpkin": "урезана бундева",
  "block.minecraft.netherrack": "недер камен",
  "block.minecraft.soul_sand": "песак душа",
  "block.minecraft.soul_soil": "душевно тло",
  "block.minecraft.basalt": "базалт",
  "block.minecraft.polished_basalt": "полирани базалт",
  "block.minecraft.soul_torch": "бакља душа",
  "block.minecraft.glowstone": "жаркамен",
  "block.minecraft.jack_o_lantern": "светлећа бундева",
  "block.minecraft.oak_trapdoor": "окно од храстовине",
  "block.minecraft.spruce_trapdoor": "окно од смреке",
  "block.minecraft.birch_trapdoor": "окно од брезе",
  "block.minecraft.jungle_trapdoor": "окно од дрвета џунгле",
  "block.minecraft.acacia_trapdoor": "окно од багрема",
  "block.minecraft.dark_oak_trapdoor": "окно од тамне храстовине",
  "block.minecraft.crimson_trapdoor": "гримизно окно",
  "block.minecraft.warped_trapdoor": "изопачено окно",
  "block.minecraft.infested_stone": "заражени камен",
  "block.minecraft.infested_cobblestone": "заражена калдрма",
  "block.minecraft.infested_stone_bricks": "заражене камене цигле",
  "block.minecraft.infested_mossy_stone_bricks": "заражене камене цигле са маховином",
  "block.minecraft.infested_cracked_stone_bricks": "заражене напукле камене цигле",
  "block.minecraft.infested_chiseled_stone_bricks": "заражене исклесане камене цигле",
  "block.minecraft.stone_bricks": "камене цигле",
  "block.minecraft.mossy_stone_bricks": "камене цигле са маховином",
  "block.minecraft.cracked_stone_bricks": "напукле камене цигле",
  "block.minecraft.chiseled_stone_bricks": "исклесане камене цигле",
  "block.minecraft.brown_mushroom_block": "блок браон печурке",
  "block.minecraft.red_mushroom_block": "блок црвене печурке",
  "block.minecraft.mushroom_stem": "стабљика печурке",
  "block.minecraft.iron_bars": "гвоздене решетке",
  "block.minecraft.chain": "ланац",
  "block.minecraft.glass_pane": "стаклена плоча",
  "block.minecraft.melon": "лубеница",
  "block.minecraft.vine": "лијане",
  "block.minecraft.oak_fence_gate": "капија од храста",
  "block.minecraft.spruce_fence_gate": "капија од смреке",
  "block.minecraft.birch_fence_gate": "капија од брезовине",
  "block.minecraft.jungle_fence_gate": "капија од дрвета џунгле",
  "block.minecraft.acacia_fence_gate": "капија од багрема",
  "block.minecraft.dark_oak_fence_gate": "капија тамне храстовине",
  "block.minecraft.crimson_fence_gate": "гримизна капија",
  "block.minecraft.warped_fence_gate": "изопачена капија",
  "block.minecraft.brick_stairs": "циглене степенице",
  "block.minecraft.stone_brick_stairs": "степенице од камене цигле",
  "block.minecraft.mycelium": "мицелијум",
  "block.minecraft.lily_pad": "локвањ",
  "block.minecraft.nether_bricks": "недер циглe",
  "block.minecraft.cracked_nether_bricks": "напукле недер цигле",
  "block.minecraft.chiseled_nether_bricks": "исклесане недер цигле",
  "block.minecraft.nether_brick_fence": "ограда од недер цигле",
  "block.minecraft.nether_brick_stairs": "степенице од недер цигле",
  "block.minecraft.enchanting_table": "сто за чарање",
  "block.minecraft.end_portal_frame": "рам од енд портала",
  "block.minecraft.end_stone": "енд камен",
  "block.minecraft.end_stone_bricks": "енд камен цигле",
  "block.minecraft.dragon_egg": "змајево јаје",
  "block.minecraft.redstone_lamp": "редстоун лампа",
  "block.minecraft.sandstone_stairs": "степенице од пешчара",
  "block.minecraft.emerald_ore": "руда смарагда",
  "block.minecraft.ender_chest": "ендер ковчег",
  "block.minecraft.tripwire_hook": "кука за нагазну жицу",
  "block.minecraft.emerald_block": "блок смарагда",
  "block.minecraft.spruce_stairs": "степенице од смреке",
  "block.minecraft.birch_stairs": "степенице од брезе",
  "block.minecraft.jungle_stairs": "степенице од дрвета из џунгле",
  "block.minecraft.crimson_stairs": "гримизне степенице",
  "block.minecraft.warped_stairs": "изопачене степенице",
  "block.minecraft.command_block": "командни блок",
  "block.minecraft.beacon": "светионик",
  "block.minecraft.cobblestone_wall": "зид од калдрме",
  "block.minecraft.mossy_cobblestone_wall": "зид од калдрме са маховином",
  "block.minecraft.brick_wall": "циглани зид",
  "block.minecraft.prismarine_wall": "зид од призмарина",
  "block.minecraft.red_sandstone_wall": "зид од црвеног пешчара",
  "block.minecraft.mossy_stone_brick_wall": "зид од камених цигла са маховином",
  "block.minecraft.granite_wall": "зид од гранита",
  "block.minecraft.stone_brick_wall": "зид од камених цигли",
  "block.minecraft.nether_brick_wall": "зид од цигала из недера",
  "block.minecraft.andesite_wall": "зид од андезита",
  "block.minecraft.red_nether_brick_wall": "зид од црвених цигала из недера",
  "block.minecraft.sandstone_wall": "зид од пешчара",
  "block.minecraft.end_stone_brick_wall": "зид од камених енд цигала",
  "block.minecraft.diorite_wall": "зид од диорита",
  "block.minecraft.blackstone_wall": "зид од црне калдрме",
  "block.minecraft.polished_blackstone_wall": "зид од полиране црне калдрме",
  "block.minecraft.polished_blackstone_brick_wall": "полирани зид од цигала црне калдрме",
  "block.minecraft.stone_button": "камено дугме",
  "block.minecraft.oak_button": "храстово дугме",
  "block.minecraft.spruce_button": "дугме од смреке",
  "block.minecraft.birch_button": "дугме од брезе",
  "block.minecraft.jungle_button": "дугме од дрвета џунгле",
  "block.minecraft.acacia_button": "дугме од багрема",
  "block.minecraft.dark_oak_button": "дугме од тамног храста",
  "block.minecraft.crimson_button": "гримизно дугме",
  "block.minecraft.warped_button": "изопачено дугме",
  "block.minecraft.polished_blackstone_button": "дугме од полиране црне калдрме",
  "block.minecraft.anvil": "наковањ",
  "block.minecraft.chipped_anvil": "окрњен наковањ",
  "block.minecraft.damaged_anvil": "oштећен наковањ",
  "block.minecraft.trapped_chest": "ковчег са замком",
  "block.minecraft.light_weighted_pressure_plate": "лака потисна плоча",
  "block.minecraft.heavy_weighted_pressure_plate": "тешка потисна плоча",
  "block.minecraft.daylight_detector": "сензор за сунчеву светлост",
  "block.minecraft.redstone_block": "блок редстоуна",
  "block.minecraft.nether_quartz_ore": "руда недер кварца",
  "block.minecraft.hopper": "левак",
  "block.minecraft.chiseled_quartz_block": "исклесани кварц",
  "block.minecraft.quartz_block": "блок кварца",
  "block.minecraft.quartz_bricks": "цигле од кварца",
  "block.minecraft.quartz_pillar": "стуб од кварца",
  "block.minecraft.quartz_stairs": "степенице од кварца",
  "block.minecraft.activator_rail": "пруга активатор",
  "block.minecraft.dropper": "избацивач",
  "block.minecraft.white_terracotta": "бела теракота",
  "block.minecraft.orange_terracotta": "наранџаста теракота",
  "block.minecraft.magenta_terracotta": "пурпурноцрвена теракота",
  "block.minecraft.light_blue_terracotta": "светло плава теракота",
  "block.minecraft.yellow_terracotta": "жута теракота",
  "block.minecraft.lime_terracotta": "светло зелена теракота",
  "block.minecraft.pink_terracotta": "розе теракота",
  "block.minecraft.gray_terracotta": "сива теракота",
  "block.minecraft.light_gray_terracotta": "светло сива теракота",
  "block.minecraft.cyan_terracotta": "цијан теракота",
  "block.minecraft.purple_terracotta": "љубичаста теракота",
  "block.minecraft.blue_terracotta": "плава теракота",
  "block.minecraft.brown_terracotta": "браон теракота",
  "block.minecraft.green_terracotta": "зелена теракота",
  "block.minecraft.red_terracotta": "црвена теракота",
  "block.minecraft.black_terracotta": "црна теракота",
  "block.minecraft.barrier": "препрека",
  "block.minecraft.iron_trapdoor": "гвоздено окно",
  "block.minecraft.hay_block": "бала сена",
  "block.minecraft.white_carpet": "бели тепих",
  "block.minecraft.orange_carpet": "наранџасти тепих",
  "block.minecraft.magenta_carpet": "магента тепих",
  "block.minecraft.light_blue_carpet": "светло плави тепих",
  "block.minecraft.yellow_carpet": "жути тепих",
  "block.minecraft.lime_carpet": "светло зелени тепих",
  "block.minecraft.pink_carpet": "розе тепих",
  "block.minecraft.gray_carpet": "сиви тепих",
  "block.minecraft.light_gray_carpet": "светло сиви тепих",
  "block.minecraft.cyan_carpet": "цијан тепих",
  "block.minecraft.purple_carpet": "љубичасти тепих",
  "block.minecraft.blue_carpet": "плави тепих",
  "block.minecraft.brown_carpet": "браон тепих",
  "block.minecraft.green_carpet": "зелени тепих",
  "block.minecraft.red_carpet": "црвени тепих",
  "block.minecraft.black_carpet": "црни тепих",
  "block.minecraft.terracotta": "теракота",
  "block.minecraft.coal_block": "блок угља",
  "block.minecraft.packed_ice": "дебели лед",
  "block.minecraft.acacia_stairs": "степенице багремовог дрвета",
  "block.minecraft.dark_oak_stairs": "степенице тамног храста",
  "block.minecraft.slime_block": "блок слузи",
  "block.minecraft.grass_path": "травната путања",
  "block.minecraft.sunflower": "сунцокрет",
  "block.minecraft.lilac": "јоргован",
  "block.minecraft.rose_bush": "жбун ружа",
  "block.minecraft.peony": "божур",
  "block.minecraft.tall_grass": "висока трава",
  "block.minecraft.large_fern": "велики папрат",
  "block.minecraft.white_stained_glass": "бело обојено стакло",
  "block.minecraft.orange_stained_glass": "наранџасто обојено стакло",
  "block.minecraft.magenta_stained_glass": "магента обојено стакло",
  "block.minecraft.light_blue_stained_glass": "светло плаво обојено стакло",
  "block.minecraft.yellow_stained_glass": "жуто обојено стакло",
  "block.minecraft.lime_stained_glass": "светло зелено обојено стакло",
  "block.minecraft.pink_stained_glass": "розе обојено стакло",
  "block.minecraft.gray_stained_glass": "сиво обојено стакло",
  "block.minecraft.light_gray_stained_glass": "светло сиво обојено стакло",
  "block.minecraft.cyan_stained_glass": "цијан обојено стакло",
  "block.minecraft.purple_stained_glass": "љубичасто обојено стакло",
  "block.minecraft.blue_stained_glass": "плаво обојено стакло",
  "block.minecraft.brown_stained_glass": "враон обојено стакло",
  "block.minecraft.green_stained_glass": "зелено обојено стакло",
  "block.minecraft.red_stained_glass": "црвено обојено стакло",
  "block.minecraft.black_stained_glass": "црно обојено стакло",
  "block.minecraft.white_stained_glass_pane": "бела стаклена плоча",
  "block.minecraft.orange_stained_glass_pane": "наранџаста стаклена плоча",
  "block.minecraft.magenta_stained_glass_pane": "магента стаклена плоча",
  "block.minecraft.light_blue_stained_glass_pane": "светло плава стаклена плоча",
  "block.minecraft.yellow_stained_glass_pane": "жута стаклена плоча",
  "block.minecraft.lime_stained_glass_pane": "светло зелена стаклена плоча",
  "block.minecraft.pink_stained_glass_pane": "розе стаклена плоча",
  "block.minecraft.gray_stained_glass_pane": "сива стаклена плоча",
  "block.minecraft.light_gray_stained_glass_pane": "светло сива стаклена плоча",
  "block.minecraft.cyan_stained_glass_pane": "цијан стаклена плоча",
  "block.minecraft.purple_stained_glass_pane": "љубичаста стаклена плоча",
  "block.minecraft.blue_stained_glass_pane": "плава стаклена плоча",
  "block.minecraft.brown_stained_glass_pane": "браон стаклена плоча",
  "block.minecraft.green_stained_glass_pane": "зелена стаклена плоча",
  "block.minecraft.red_stained_glass_pane": "црвена стаклена плоча",
  "block.minecraft.black_stained_glass_pane": "црна стаклена плоча",
  "block.minecraft.prismarine": "призмарин",
  "block.minecraft.prismarine_bricks": "блок призмарина",
  "block.minecraft.dark_prismarine": "тамни призмарин",
  "block.minecraft.prismarine_stairs": "cтепенице призмарина",
  "block.minecraft.prismarine_brick_stairs": "степенице призмаринске цигле",
  "block.minecraft.dark_prismarine_stairs": "тамне степенице призмарина",
  "block.minecraft.sea_lantern": "морски фењер",
  "block.minecraft.red_sandstone": "црвени пешчар",
  "block.minecraft.chiseled_red_sandstone": "исклесани црвени пешчар",
  "block.minecraft.cut_red_sandstone": "сечени црвени пешчар",
  "block.minecraft.red_sandstone_stairs": "степенице црвеног пешчара",
  "block.minecraft.repeating_command_block": "понављајући командни блок",
  "block.minecraft.chain_command_block": "везни командни блок",
  "block.minecraft.magma_block": "блок магме",
  "block.minecraft.nether_wart_block": "блок недер лишаја",
  "block.minecraft.warped_wart_block": "изопачени блок од лишајева",
  "block.minecraft.red_nether_bricks": "црвене недер цигле",
  "block.minecraft.bone_block": "блок од костију",
  "block.minecraft.structure_void": "структурна празнина",
  "block.minecraft.observer": "посматрач",
  "block.minecraft.shulker_box": "шулкер кутија",
  "block.minecraft.white_shulker_box": "бела шулкер кутија",
  "block.minecraft.orange_shulker_box": "наранџаста шулкер кутија",
  "block.minecraft.magenta_shulker_box": "пурпурноцрвена шулкер кутија",
  "block.minecraft.light_blue_shulker_box": "светло плава шулкер кутија",
  "block.minecraft.yellow_shulker_box": "жута шулкер кутија",
  "block.minecraft.lime_shulker_box": "светло зелена шулкер кутија",
  "block.minecraft.pink_shulker_box": "роза шулкер кутија",
  "block.minecraft.gray_shulker_box": "сива шулкер кутија",
  "block.minecraft.light_gray_shulker_box": "светло сива шулкер кутија",
  "block.minecraft.cyan_shulker_box": "цијан шулкер кутија",
  "block.minecraft.purple_shulker_box": "љубичаста шулкер кутија",
  "block.minecraft.blue_shulker_box": "тамно плава шулкер кутија",
  "block.minecraft.brown_shulker_box": "браон шулкер кутија",
  "block.minecraft.green_shulker_box": "зелена шулкер кутија",
  "block.minecraft.red_shulker_box": "црвена шулкер кутија",
  "block.minecraft.black_shulker_box": "црна шулкер кутија",
  "block.minecraft.white_glazed_terracotta": "теракота са глазуром беле",
  "block.minecraft.orange_glazed_terracotta": "теракота са глазуром наранџасте",
  "block.minecraft.magenta_glazed_terracotta": "теракота са глазуром пурпурноцрвене",
  "block.minecraft.light_blue_glazed_terracotta": "теракота са глазуром светло беле",
  "block.minecraft.yellow_glazed_terracotta": "теракота са глазуром жуте",
  "block.minecraft.lime_glazed_terracotta": "теракота са глазуром светло зелене",
  "block.minecraft.pink_glazed_terracotta": "теракота са пинк глазуром",
  "block.minecraft.gray_glazed_terracotta": "теракота са глазуром сиве",
  "block.minecraft.light_gray_glazed_terracotta": "теракота са глазуром светло сиве",
  "block.minecraft.cyan_glazed_terracotta": "теракота са цијан глазуром",
  "block.minecraft.purple_glazed_terracotta": "теракота са глазуром љубичасте",
  "block.minecraft.blue_glazed_terracotta": "теракота са глазуром плаве",
  "block.minecraft.brown_glazed_terracotta": "теракота са глазуром браон",
  "block.minecraft.green_glazed_terracotta": "теракота са глазуром зелене",
  "block.minecraft.red_glazed_terracotta": "теракота са глазуром црвене",
  "block.minecraft.black_glazed_terracotta": "теракота са глазуром црне",
  "block.minecraft.white_concrete": "бели бетон",
  "block.minecraft.orange_concrete": "наранџасти бетон",
  "block.minecraft.magenta_concrete": "магента бетон",
  "block.minecraft.light_blue_concrete": "светло плави бетон",
  "block.minecraft.yellow_concrete": "жути бетон",
  "block.minecraft.lime_concrete": "светло зелени бетон",
  "block.minecraft.pink_concrete": "розе бетон",
  "block.minecraft.gray_concrete": "сиви бетон",
  "block.minecraft.light_gray_concrete": "светло сиви бетон",
  "block.minecraft.cyan_concrete": "цијан бетон",
  "block.minecraft.purple_concrete": "љубичасти бетон",
  "block.minecraft.blue_concrete": "плави бетон",
  "block.minecraft.brown_concrete": "браон бетон",
  "block.minecraft.green_concrete": "зелени бетон",
  "block.minecraft.red_concrete": "црвени бетон",
  "block.minecraft.black_concrete": "црни бетон",
  "block.minecraft.white_concrete_powder": "бели бетон у праху",
  "block.minecraft.orange_concrete_powder": "наранџасти бетон у праху",
  "block.minecraft.magenta_concrete_powder": "пурпурноцрвен бетон у праху",
  "block.minecraft.light_blue_concrete_powder": "светло плави бетон у праху",
  "block.minecraft.yellow_concrete_powder": "жути бетон у праху",
  "block.minecraft.lime_concrete_powder": "светло зелени бетон у праху",
  "block.minecraft.pink_concrete_powder": "пинк бетон у праху",
  "block.minecraft.gray_concrete_powder": "сиви бетон у праху",
  "block.minecraft.light_gray_concrete_powder": "светло сиви бетон у праху",
  "block.minecraft.cyan_concrete_powder": "цијан бетон у праху",
  "block.minecraft.purple_concrete_powder": "љубичасти бетон у праху",
  "block.minecraft.blue_concrete_powder": "плави бетон у праху",
  "block.minecraft.brown_concrete_powder": "браон бетон у праху",
  "block.minecraft.green_concrete_powder": "зелени бетон у праху",
  "block.minecraft.red_concrete_powder": "црвени бетон у праху",
  "block.minecraft.black_concrete_powder": "црни бетон у праху",
  "block.minecraft.turtle_egg": "јаје корњаче",
  "block.minecraft.dead_tube_coral_block": "блок мртвог цевастог корала",
  "block.minecraft.dead_brain_coral_block": "блок мртвог набораног корала",
  "block.minecraft.dead_bubble_coral_block": "блок мртвог мехурастог корала",
  "block.minecraft.dead_fire_coral_block": "блок мртвог ватреног корала",
  "block.minecraft.dead_horn_coral_block": "блок мртвог рогастог корала",
  "block.minecraft.tube_coral_block": "блок цевастог корала",
  "block.minecraft.brain_coral_block": "блок набораног корала",
  "block.minecraft.bubble_coral_block": "блок мехурастог корала",
  "block.minecraft.fire_coral_block": "ватрени корални блок",
  "block.minecraft.horn_coral_block": "рогасти корални блок",
  "block.minecraft.tube_coral": "цевасти корал",
  "block.minecraft.brain_coral": "наборани корал",
  "block.minecraft.bubble_coral": "мехурасти корал",
  "block.minecraft.fire_coral": "ватрени корал",
  "block.minecraft.horn_coral": "рогасти корал",
  "block.minecraft.dead_brain_coral": "мртви наборани корал",
  "block.minecraft.dead_bubble_coral": "мртви мехурасти корал",
  "block.minecraft.dead_fire_coral": "мртви ватрени корал",
  "block.minecraft.dead_horn_coral": "мртви рогасти корал",
  "block.minecraft.dead_tube_coral": "мртви цевасти корал",
  "block.minecraft.tube_coral_fan": "цеваста корална лепеза",
  "block.minecraft.brain_coral_fan": "наборана корална лепеза",
  "block.minecraft.bubble_coral_fan": "мехураста корална лепеза",
  "block.minecraft.fire_coral_fan": "ватрена корална лепеза",
  "block.minecraft.horn_coral_fan": "рогаста корална лепеза",
  "block.minecraft.dead_tube_coral_fan": "мртва цеваста корална лепеза",
  "block.minecraft.dead_brain_coral_fan": "мртва наборана корална лепеза",
  "block.minecraft.dead_bubble_coral_fan": "мртва мехураста корална лепеза",
  "block.minecraft.dead_fire_coral_fan": "мртва ватрена корална лепеза",
  "block.minecraft.dead_horn_coral_fan": "мртва рогаста корална лепеза",
  "block.minecraft.blue_ice": "плави лед",
  "block.minecraft.conduit": "цевовод",
  "block.minecraft.polished_granite_stairs": "полиране степенице од гранита",
  "block.minecraft.smooth_red_sandstone_stairs": "глатке степенице од црвеног пешчара",
  "block.minecraft.mossy_stone_brick_stairs": "степенице од цигла са маховином",
  "block.minecraft.polished_diorite_stairs": "полиране степенице од диорита",
  "block.minecraft.mossy_cobblestone_stairs": "степенице од камења са маховином",
  "block.minecraft.end_stone_brick_stairs": "степенице од камених енд цигала",
  "block.minecraft.stone_stairs": "степенице од камења",
  "block.minecraft.smooth_sandstone_stairs": "глатке степенице од пешчара",
  "block.minecraft.smooth_quartz_stairs": "глатке степенице од кварца",
  "block.minecraft.granite_stairs": "степенице од гранита",
  "block.minecraft.andesite_stairs": "степенице од андезита",
  "block.minecraft.red_nether_brick_stairs": "степенице од црвених цигла из недера",
  "block.minecraft.polished_andesite_stairs": "полиране степенице од андезита",
  "block.minecraft.diorite_stairs": "степенице од диорита",
  "block.minecraft.polished_granite_slab": "полирана плоча од гранита",
  "block.minecraft.smooth_red_sandstone_slab": "глатка плоча од црвеног пешчара",
  "block.minecraft.mossy_stone_brick_slab": "плоче од камења са маховином",
  "block.minecraft.polished_diorite_slab": "полирана плоча од диорита",
  "block.minecraft.mossy_cobblestone_slab": "плоча од камена са маховином",
  "block.minecraft.end_stone_brick_slab": "плоча од камених енд цигала",
  "block.minecraft.smooth_sandstone_slab": "глатка плоча од пешчара",
  "block.minecraft.smooth_quartz_slab": "глатка плоча од кварца",
  "block.minecraft.granite_slab": "плоча од гранита",
  "block.minecraft.andesite_slab": "плота од андезита",
  "block.minecraft.red_nether_brick_slab": "плоча од црвених цигла из недера",
  "block.minecraft.polished_andesite_slab": "полирана плоча од андезита",
  "block.minecraft.diorite_slab": "плоча од диорита",
  "block.minecraft.scaffolding": "скеле",
  "block.minecraft.iron_door": "гвоздена врата",
  "block.minecraft.oak_door": "врата од храстовине",
  "block.minecraft.spruce_door": "врата од смреке",
  "block.minecraft.birch_door": "врата од брезовине",
  "block.minecraft.jungle_door": "врата дрвета џунгле",
  "block.minecraft.acacia_door": "врата од багрема",
  "block.minecraft.dark_oak_door": "врата од тамне храстовине",
  "block.minecraft.crimson_door": "гримизна врата",
  "block.minecraft.warped_door": "изопачена врата",
  "block.minecraft.repeater": "редстоун појачивач",
  "block.minecraft.comparator": "редстоун компаратор",
  "block.minecraft.structure_block": "структурни блок",
  "block.minecraft.jigsaw": "блок слагалица",
  "item.minecraft.turtle_helmet": "оклоп корњаче□□када је на глави:□+2 оклоп",
  "item.minecraft.scute": "скута",
  "item.minecraft.iron_shovel": "гвоздена лопата□□када је у главној руци:□+3.5 јачина напада□-3 брзина напада",
  "item.minecraft.iron_pickaxe": "гвоздени крамп□□када је у главној руци:□+3 јачина напада□-2.8 брзина напада",
  "item.minecraft.iron_axe": "гвоздена секира□□када је у главној руци:□+8 јачина напада□-3.1 брзина напада",
  "item.minecraft.flint_and_steel": "кремен и челик",
  "item.minecraft.apple": "јабука",
  "item.minecraft.bow": "лук",
  "item.minecraft.arrow": "стрела",
  "item.minecraft.coal": "угаљ",
  "item.minecraft.charcoal": "дрвени угаљ",
  "item.minecraft.diamond": "дијамант",
  "item.minecraft.iron_ingot": "гвоздена полуга",
  "item.minecraft.gold_ingot": "златна полуга",
  "item.minecraft.netherite_ingot": "недерит полуга",
  "item.minecraft.netherite_scrap": "одломак недерита",
  "item.minecraft.iron_sword": "гвоздени мач□□када је у главној руци:□+5 јачина напада□-2.4 брзина напада",
  "item.minecraft.wooden_sword": "дрвени мач□□када је у главној руци:□+3 јачина напада□-2.4 брзина напада",
  "item.minecraft.wooden_shovel": "дрвена лопата□□када је у главној руци:□+1.5 јачина напада□-3 брзина напада",
  "item.minecraft.wooden_pickaxe": "дрвени крамп□□када је у главној руци:□+1 јачина напада□-2.8 брзина напада",
  "item.minecraft.wooden_axe": "дрвена секира□□када је у главној руци:□+6 јачина напада□-3.2 брзина напада",
  "item.minecraft.stone_sword": "камени мач□□када је у главној руци:□+4 јачина напада□-2.4 брзина напада",
  "item.minecraft.stone_shovel": "камена лопата□□када је у главној руци:□+2.5 јачина напада□-3 брзина напада",
  "item.minecraft.stone_pickaxe": "камени крамп□□када је у главној руци:□+2 јачина напада□-2.8 брзина напада",
  "item.minecraft.stone_axe": "камена секира□□када је у главној руци:□+8 јачина напада□-3.2 брзина напада",
  "item.minecraft.diamond_sword": "дијамантски мач□□када је у главној руци:□+6 јачина напада□-2.4 брзина напада",
  "item.minecraft.diamond_shovel": "дијамантска лопата□□када је у главној руци:□+4.5 јачина напада□-3 брзина напада",
  "item.minecraft.diamond_pickaxe": "дијамантски крамп□□када је у главној руци:□+4 јачина напада□-2.8 брзина напада",
  "item.minecraft.diamond_axe": "дијамантска секира□□када је у главној руци:□+8 јачина напада□-3 брзина напада",
  "item.minecraft.stick": "штап",
  "item.minecraft.bowl": "чинија",
  "item.minecraft.mushroom_stew": "паприкаш од печурака",
  "item.minecraft.golden_sword": "златни мач□□када је у главној руци:□+3 јачина напада□-2.4 брзина напада",
  "item.minecraft.golden_shovel": "златна лопата□□када је у главној руци:□+1.5 јачина напада□-3 брзина напада",
  "item.minecraft.golden_pickaxe": "златни крамп□□када је у главној руци:□+1 јачина напада□-2.8 брзина напада",
  "item.minecraft.golden_axe": "златна секира□□када је у главној руци:□+6 јачина напада□-3 брзина напада",
  "item.minecraft.netherite_sword": "недеритски мач□□када је у главној руци:□+7 јачина напада□-2.4 брзина напада",
  "item.minecraft.netherite_shovel": "недеритска лопата□□када је у главној руци:□+5.5 јачина напада□-3 брзина напада",
  "item.minecraft.netherite_pickaxe": "недеритски крамп□□када је у главној руци:□+5 јачина напада□-2.8 брзина напада",
  "item.minecraft.netherite_axe": "недеритска секира□□када је у главној руци:□+9 јачина напада□-3 брзина напада",
  "item.minecraft.string": "нит",
  "item.minecraft.feather": "перо",
  "item.minecraft.gunpowder": "барут",
  "item.minecraft.wooden_hoe": "дрвена мотика□□када је у главној руци:□-3 брзина напада",
  "item.minecraft.stone_hoe": "камена мотика□□када је у главној руци:□-2 брзина напада",
  "item.minecraft.iron_hoe": "гвоздена мотика□□када је у главној руци:□-1 брзина напада",
  "item.minecraft.diamond_hoe": "дијамантска мотика□□када је у главној руци:",
  "item.minecraft.golden_hoe": "златна мотика□□када је у главној руци:□-3 брзина напада",
  "item.minecraft.netherite_hoe": "недеритска мотика□□када је у главној руци:",
  "item.minecraft.wheat_seeds": "семе пшенице",
  "item.minecraft.wheat": "пшеница",
  "item.minecraft.bread": "хлеб",
  "item.minecraft.leather_helmet": "кожна капа□□када је на глави:□+1 оклоп",
  "item.minecraft.leather_chestplate": "кожни прслук□□када је на телу:□+3 оклоп",
  "item.minecraft.leather_leggings": "кожне панталоне□□када је на ногама:□+2 оклоп",
  "item.minecraft.leather_boots": "кожне чизме□□када је на стопалима:□+1 оклоп",
  "item.minecraft.chainmail_helmet": "верижна капуљача□□када је на глави:□+2 оклоп",
  "item.minecraft.chainmail_chestplate": "верижњача□□када је на телу:□+5 оклоп",
  "item.minecraft.chainmail_leggings": "верижне ногавице□□када је на ногама:□+4 оклоп",
  "item.minecraft.chainmail_boots": "верижне чизме□□када је на стопалима:□+1 оклоп",
  "item.minecraft.iron_helmet": "гвоздени шлем□□када је на глави:□+2 оклоп",
  "item.minecraft.iron_chestplate": "гвоздени нагрудник□□када је на телу:□+6 оклоп",
  "item.minecraft.iron_leggings": "гвоздене панталоне□□када је на ногама:□+5 оклоп",
  "item.minecraft.iron_boots": "гвоздене чизме□□када је на стопалима:□+2 оклоп",
  "item.minecraft.diamond_helmet": "дијамантски шлем□□када је на глави:□+3 оклоп□+2 осетљивост оклопа",
  "item.minecraft.diamond_chestplate": "дијамантски нагрудник□□када је на телу:□+8 оклоп□+2 осетљивост оклопа",
  "item.minecraft.diamond_leggings": "дијамантске панталоне□□када је на ногама:□+6 оклоп□+2 осетљивост оклопа",
  "item.minecraft.diamond_boots": "дијамантске чизме□□када је на стопалима:□+3 оклоп□+2 осетљивост оклопа",
  "item.minecraft.golden_helmet": "златни шлем□□када је на глави:□+2 оклоп",
  "item.minecraft.golden_chestplate": "златни нагрудник□□када је на телу:□+5 оклоп",
  "item.minecraft.golden_leggings": "златне панталоне□□када је на ногама:□+3 оклоп",
  "item.minecraft.golden_boots": "златне чизме□□када је на стопалима:□+1 оклоп",
  "item.minecraft.netherite_helmet": "недеритска кацига□□када је на глави:□+3 оклоп□+3 осетљивост оклопа□+1 отпорност на одбацивање",
  "item.minecraft.netherite_chestplate": "недеритски нагрудник□□када је на телу:□+8 оклоп□+3 осетљивост оклопа□+1 отпорност на одбацивање",
  "item.minecraft.netherite_leggings": "недеритске панталоне□□када је на ногама:□+6 оклоп□+3 осетљивост оклопа□+1 отпорност на одбацивање",
  "item.minecraft.netherite_boots": "недеритске чизме□□када је на стопалима:□+3 оклоп□+3 осетљивост оклопа□+1 отпорност на одбацивање",
  "item.minecraft.flint": "кремен",
  "item.minecraft.porkchop": "сирова крменадла",
  "item.minecraft.cooked_porkchop": "печена крменадла",
  "item.minecraft.painting": "слика",
  "item.minecraft.golden_apple": "златна јабука",
  "item.minecraft.enchanted_golden_apple": "очарана златна јабука",
  "block.minecraft.oak_sign": "знак од храста",
  "block.minecraft.spruce_sign": "знак од смреке",
  "block.minecraft.birch_sign": "знак од брезе",
  "block.minecraft.jungle_sign": "знак од дрвета из џунгле",
  "block.minecraft.acacia_sign": "знак од акација",
  "block.minecraft.dark_oak_sign": "знак од мрачног храста",
  "block.minecraft.crimson_sign": "гримизни знак",
  "block.minecraft.warped_sign": "изопачени знак",
  "item.minecraft.bucket": "кофа",
  "item.minecraft.water_bucket": "кофа са водом",
  "item.minecraft.lava_bucket": "кофа са лавом",
  "item.minecraft.minecart": "рударска колица",
  "item.minecraft.saddle": "седло",
  "item.minecraft.redstone": "редстоун прах",
  "item.minecraft.snowball": "грудва",
  "item.minecraft.oak_boat": "чамац од храста",
  "item.minecraft.leather": "кожа",
  "item.minecraft.milk_bucket": "кофа млека",
  "item.minecraft.pufferfish_bucket": "канта фугу рибе",
  "item.minecraft.salmon_bucket": "кофа лососа",
  "item.minecraft.cod_bucket": "кофа бакалара",
  "item.minecraft.tropical_fish_bucket": "кофа тропске рибе",
  "item.minecraft.brick": "цигла",
  "item.minecraft.clay_ball": "глинена лопта",
  "block.minecraft.dried_kelp_block": "осушени блок морских алги",
  "item.minecraft.paper": "папир",
  "item.minecraft.book": "књига",
  "item.minecraft.slime_ball": "лопта од слузи",
  "item.minecraft.chest_minecart": "колица са ковчегом",
  "item.minecraft.furnace_minecart": "колица са пећницом",
  "item.minecraft.egg": "jaje",
  "item.minecraft.compass": "компас",
  "item.minecraft.fishing_rod": "штап за пецање",
  "item.minecraft.clock": "сат",
  "item.minecraft.glowstone_dust": "прах жаркамена",
  "item.minecraft.cod": "сиров бакалар",
  "item.minecraft.salmon": "сирови лосос",
  "item.minecraft.tropical_fish": "тропска риба",
  "item.minecraft.pufferfish": "фугу риба",
  "item.minecraft.cooked_cod": "кувани бакалар",
  "item.minecraft.cooked_salmon": "куван лосос",
  "item.minecraft.ink_sac": "врећица с мастилом",
  "item.minecraft.red_dye": "црвена боја",
  "item.minecraft.green_dye": "зелена боја",
  "item.minecraft.cocoa_beans": "какао зрневље",
  "item.minecraft.lapis_lazuli": "лапис лазули",
  "item.minecraft.purple_dye": "љубичасти пигмент",
  "item.minecraft.cyan_dye": "цијан пигмент",
  "item.minecraft.light_gray_dye": "светло сиви пигмент",
  "item.minecraft.gray_dye": "сиви пигмент",
  "item.minecraft.pink_dye": "розе пигмент",
  "item.minecraft.lime_dye": "светло зелени пигмент",
  "item.minecraft.yellow_dye": "жута боја",
  "item.minecraft.light_blue_dye": "светло плави пигмент",
  "item.minecraft.magenta_dye": "магента пигмент",
  "item.minecraft.orange_dye": "наранџасти пигмент",
  "item.minecraft.bone_meal": "коштано брашно",
  "item.minecraft.blue_dye": "плава боја",
  "item.minecraft.brown_dye": "браон боја",
  "item.minecraft.black_dye": "црна боја",
  "item.minecraft.white_dye": "бела боја",
  "item.minecraft.bone": "кост",
  "item.minecraft.sugar": "шећер",
  "block.minecraft.cake": "торта",
  "block.minecraft.white_bed": "бео кревет",
  "block.minecraft.orange_bed": "наранџасти кревет",
  "block.minecraft.magenta_bed": "магента кревет",
  "block.minecraft.light_blue_bed": "светло плав кревет",
  "block.minecraft.yellow_bed": "жут кревет",
  "block.minecraft.lime_bed": "светло зелен кревет",
  "block.minecraft.pink_bed": "розе кревет",
  "block.minecraft.gray_bed": "сив кревет",
  "block.minecraft.light_gray_bed": "светло сив кревет",
  "block.minecraft.cyan_bed": "цијан кревет",
  "block.minecraft.purple_bed": "љубичаст кревет",
  "block.minecraft.blue_bed": "плав кревет",
  "block.minecraft.brown_bed": "браон кревет",
  "block.minecraft.green_bed": "зелен кревет",
  "block.minecraft.red_bed": "црвен кревет",
  "block.minecraft.black_bed": "црн кревет",
  "item.minecraft.cookie": "колачић",
  "item.minecraft.filled_map": "мапа□#0",
  "item.minecraft.shears": "маказе",
  "item.minecraft.melon_slice": "кришка лубенице",
  "item.minecraft.dried_kelp": "осушена морска алга",
  "item.minecraft.pumpkin_seeds": "семе бундеве",
  "item.minecraft.melon_seeds": "семе лубенице",
  "item.minecraft.beef": "сирова говедина",
  "item.minecraft.cooked_beef": "бифтек",
  "item.minecraft.chicken": "сирова пилетина",
  "item.minecraft.cooked_chicken": "печено пиле",
  "item.minecraft.rotten_flesh": "труло месо",
  "item.minecraft.ender_pearl": "ендер бисер",
  "item.minecraft.blaze_rod": "пламен-штап",
  "item.minecraft.ghast_tear": "гаст суза",
  "item.minecraft.gold_nugget": "грумен злата",
  "item.minecraft.nether_wart": "недер лишај",
  "item.minecraft.potion": "ненаправљив напитак□нема ефекта",
  "item.minecraft.glass_bottle": "стаклена боца",
  "item.minecraft.spider_eye": "пауково око",
  "item.minecraft.fermented_spider_eye": "ферментисано пауково око",
  "item.minecraft.blaze_powder": "пламен-прах",
  "item.minecraft.magma_cream": "магма крем",
  "block.minecraft.brewing_stand": "самовар за напитке",
  "block.minecraft.cauldron": "котао",
  "item.minecraft.ender_eye": "око ендера",
  "item.minecraft.glistering_melon_slice": "светлуцава кришка лубенице",
  "item.minecraft.bat_spawn_egg": "јаје слепог миша",
  "item.minecraft.bee_spawn_egg": "јаје пчеле",
  "item.minecraft.blaze_spawn_egg": "јаје пламена",
  "item.minecraft.cat_spawn_egg": "јаје мачке",
  "item.minecraft.cave_spider_spawn_egg": "јаје пећинског паука",
  "item.minecraft.chicken_spawn_egg": "јаје кокошке",
  "item.minecraft.cod_spawn_egg": "јаје бакалара",
  "item.minecraft.cow_spawn_egg": "јаје краве",
  "item.minecraft.creeper_spawn_egg": "јаје крипера",
  "item.minecraft.dolphin_spawn_egg": "јаје делфина",
  "item.minecraft.donkey_spawn_egg": "јаје магарца",
  "item.minecraft.drowned_spawn_egg": "јаје удављеног",
  "item.minecraft.elder_guardian_spawn_egg": "јаје старог чувара",
  "item.minecraft.enderman_spawn_egg": "јаје ендермена",
  "item.minecraft.endermite_spawn_egg": "јаје ендермита",
  "item.minecraft.evoker_spawn_egg": "јаје призиватеља",
  "item.minecraft.fox_spawn_egg": "јаје лисице",
  "item.minecraft.ghast_spawn_egg": "јаје гаста",
  "item.minecraft.guardian_spawn_egg": "јаје чувара",
  "item.minecraft.hoglin_spawn_egg": "јаје хоглина",
  "item.minecraft.horse_spawn_egg": "јаје коња",
  "item.minecraft.husk_spawn_egg": "јаје љуске",
  "item.minecraft.llama_spawn_egg": "јаје ламе",
  "item.minecraft.magma_cube_spawn_egg": "јаје коцке магме",
  "item.minecraft.mooshroom_spawn_egg": "јаје мушрума",
  "item.minecraft.mule_spawn_egg": "јаје мазге",
  "item.minecraft.ocelot_spawn_egg": "јаје дивље мачке",
  "item.minecraft.panda_spawn_egg": "јаје панде",
  "item.minecraft.parrot_spawn_egg": "јаје папагаја",
  "item.minecraft.phantom_spawn_egg": "јаје фантома",
  "item.minecraft.pig_spawn_egg": "јаје свиње",
  "item.minecraft.piglin_spawn_egg": "јаје праслина",
  "item.minecraft.pillager_spawn_egg": "јаје разбојника",
  "item.minecraft.polar_bear_spawn_egg": "јаје поларног медведа",
  "item.minecraft.pufferfish_spawn_egg": "јаје фугу рибе",
  "item.minecraft.rabbit_spawn_egg": "јаје зеца",
  "item.minecraft.ravager_spawn_egg": "јаје разарача",
  "item.minecraft.salmon_spawn_egg": "јаје лососа",
  "item.minecraft.sheep_spawn_egg": "јаје овце",
  "item.minecraft.shulker_spawn_egg": "јаје шулкера",
  "item.minecraft.silverfish_spawn_egg": "јаје сребрне рибе",
  "item.minecraft.skeleton_spawn_egg": "јаје костура",
  "item.minecraft.skeleton_horse_spawn_egg": "јаје костура коња",
  "item.minecraft.slime_spawn_egg": "јаје слузи",
  "item.minecraft.spider_spawn_egg": "јаје паука",
  "item.minecraft.squid_spawn_egg": "јаје лигње",
  "item.minecraft.stray_spawn_egg": "јаје луталице",
  "item.minecraft.strider_spawn_egg": "јаје шетача",
  "item.minecraft.trader_llama_spawn_egg": "jaje трговачке ламе",
  "item.minecraft.tropical_fish_spawn_egg": "јаје тропске рибе",
  "item.minecraft.turtle_spawn_egg": "јаје корњаче",
  "item.minecraft.vex_spawn_egg": "јаје напасти",
  "item.minecraft.villager_spawn_egg": "јаје сељака",
  "item.minecraft.vindicator_spawn_egg": "јаје осветника",
  "item.minecraft.wandering_trader_spawn_egg": "јаје лутајућег трговца",
  "item.minecraft.witch_spawn_egg": "јаје вештице",
  "item.minecraft.wither_skeleton_spawn_egg": "јаје видер костура",
  "item.minecraft.wolf_spawn_egg": "јаје вука",
  "item.minecraft.zoglin_spawn_egg": "јаје зоглина",
  "item.minecraft.zombie_spawn_egg": "јаје зомбија",
  "item.minecraft.zombie_horse_spawn_egg": "јаје зомби коња",
  "item.minecraft.zombie_villager_spawn_egg": "јаје сељака зомбија",
  "item.minecraft.zombified_piglin_spawn_egg": "јаје зомбификованог праслина",
  "item.minecraft.experience_bottle": "чаробна боца",
  "item.minecraft.fire_charge": "ватрена лопта",
  "item.minecraft.writable_book": "књига и перо",
  "item.minecraft.written_book": "написана књига",
  "item.minecraft.emerald": "смарагд",
  "item.minecraft.item_frame": "рам за предмет",
  "block.minecraft.flower_pot": "саксија",
  "item.minecraft.carrot": "шаргарепа",
  "item.minecraft.potato": "кромпир",
  "item.minecraft.baked_potato": "испечен кромпир",
  "item.minecraft.poisonous_potato": "отровни кромпир",
  "item.minecraft.map": "празна мапа",
  "item.minecraft.golden_carrot": "златна шаргарепа",
  "block.minecraft.skeleton_skull": "костурова лобања",
  "block.minecraft.wither_skeleton_skull": "лобања видер костура",
  "block.minecraft.player_head": "глава играча",
  "block.minecraft.zombie_head": "глава зомбија",
  "block.minecraft.creeper_head": "криперова глава",
  "block.minecraft.dragon_head": "змајева глава",
  "item.minecraft.carrot_on_a_stick": "шаргарепа на штапу",
  "item.minecraft.warped_fungus_on_a_stick": "изопачена гљива на штапу",
  "item.minecraft.nether_star": "недер звезда",
  "item.minecraft.pumpkin_pie": "пита од бундеве",
  "item.minecraft.firework_rocket": "ватрометска ракета",
  "item.minecraft.firework_star": "ватрометска звезда",
  "item.minecraft.enchanted_book": "зачарана књига",
  "item.minecraft.nether_brick": "недер цигла",
  "item.minecraft.quartz": "недер кварц",
  "item.minecraft.tnt_minecart": "колица са динамитом",
  "item.minecraft.hopper_minecart": "колица са левком",
  "item.minecraft.prismarine_shard": "крхотина призмарина",
  "item.minecraft.prismarine_crystals": "кристали призмарина",
  "item.minecraft.rabbit": "сиров зец",
  "item.minecraft.cooked_rabbit": "кувани зец",
  "item.minecraft.rabbit_stew": "зечији паприкаш",
  "item.minecraft.rabbit_foot": "зечија шапа",
  "item.minecraft.rabbit_hide": "зечије крзно",
  "item.minecraft.armor_stand": "постоље за оклоп",
  "item.minecraft.iron_horse_armor": "гвоздени оклоп за коња",
  "item.minecraft.golden_horse_armor": "златни коњски оклоп",
  "item.minecraft.diamond_horse_armor": "дијамантски оклоп за коња",
  "item.minecraft.leather_horse_armor": "кожни коњски оклоп",
  "item.minecraft.lead": "поводац",
  "item.minecraft.name_tag": "етикета",
  "item.minecraft.command_block_minecart": "колица са командним блоком",
  "item.minecraft.mutton": "сирова јагњетина",
  "item.minecraft.cooked_mutton": "кувана јагњетина",
  "block.minecraft.white_banner": "бела застава",
  "block.minecraft.orange_banner": "наранџаста застава",
  "block.minecraft.magenta_banner": "магента застава",
  "block.minecraft.light_blue_banner": "светло плава застава",
  "block.minecraft.yellow_banner": "жута застава",
  "block.minecraft.lime_banner": "светло зелена застава",
  "block.minecraft.pink_banner": "розе застава",
  "block.minecraft.gray_banner": "сива застава",
  "block.minecraft.light_gray_banner": "светло сива застава",
  "block.minecraft.cyan_banner": "цијан застава",
  "block.minecraft.purple_banner": "љубичаста застава",
  "block.minecraft.blue_banner": "плава застава",
  "block.minecraft.brown_banner": "браон застава",
  "block.minecraft.green_banner": "зелена застава",
  "block.minecraft.red_banner": "црвена застава",
  "block.minecraft.black_banner": "црна застава",
  "item.minecraft.end_crystal": "енд кристал",
  "item.minecraft.chorus_fruit": "хорус воћка",
  "item.minecraft.popped_chorus_fruit": "пукнуто хорус воће",
  "item.minecraft.beetroot": "цвекла",
  "item.minecraft.beetroot_seeds": "семе цвекле",
  "item.minecraft.beetroot_soup": "супа од цвекле",
  "item.minecraft.dragon_breath": "змајев дах",
  "item.minecraft.splash_potion": "распрскујући ненаправљиви напитак□нема ефекта",
  "item.minecraft.spectral_arrow": "спектрална стрела",
  "item.minecraft.tipped_arrow": "неправљена умочена стрела□нема ефекта",
  "item.minecraft.lingering_potion": "дуготрајни ненаправљив напитак□нема ефекта",
  "item.minecraft.shield": "штит",
  "item.minecraft.elytra": "крила",
  "item.minecraft.spruce_boat": "чамац од смрче",
  "item.minecraft.birch_boat": "чамац од брезе",
  "item.minecraft.jungle_boat": "чамац од дрвета џунгле",
  "item.minecraft.acacia_boat": "чамац од багрема",
  "item.minecraft.dark_oak_boat": "чамац од тамног храста",
  "item.minecraft.totem_of_undying": "тотем бесмрти",
  "item.minecraft.shulker_shell": "шулкер љуска",
  "item.minecraft.iron_nugget": "грумен гвожђа",
  "item.minecraft.knowledge_book": "књига знања",
  "item.minecraft.debug_stick": "штап за дебаговање",
  "item.minecraft.music_disc_13": "музичка плоча□c418 - 13",
  "item.minecraft.music_disc_cat": "музичка плоча□c418 - cat",
  "item.minecraft.music_disc_blocks": "музичка плоча□c418 - blocks",
  "item.minecraft.music_disc_chirp": "музичка плоча□c418 - chirp",
  "item.minecraft.music_disc_far": "музичка плоча□c418 - far",
  "item.minecraft.music_disc_mall": "музичка плоча□c418 - mall",
  "item.minecraft.music_disc_mellohi": "музичка плоча□c418 - mellohi",
  "item.minecraft.music_disc_stal": "музичка плоча□c418 - stal",
  "item.minecraft.music_disc_strad": "музичка плоча□c418 - strad",
  "item.minecraft.music_disc_ward": "музичка плоча□c418 - ward",
  "item.minecraft.music_disc_11": "музичка плоча□c418 - 11",
  "item.minecraft.music_disc_wait": "музичка плоча□c418 - wait",
  "item.minecraft.music_disc_pigstep": "музичка плоча□лена рејн - pigstep",
  "item.minecraft.trident": "трозубац□□када је у главној руци:□+8 јачина напада□-2.9 брзина напада",
  "item.minecraft.phantom_membrane": "фантом мембрана",
  "item.minecraft.nautilus_shell": "оклоп наутилуса",
  "item.minecraft.heart_of_the_sea": "срце мора",
  "item.minecraft.crossbow": "cамострел",
  "item.minecraft.suspicious_stew": "сумњиви паприкаш",
  "block.minecraft.loom": "разбој",
  "item.minecraft.flower_banner_pattern": "шара заставе□лик цвета",
  "item.minecraft.creeper_banner_pattern": "шара заставе□симбол крипера",
  "item.minecraft.skull_banner_pattern": "шара заставе□лик лобање",
  "item.minecraft.mojang_banner_pattern": "шара заставе□ствар",
  "item.minecraft.globe_banner_pattern": "шара заставе□глобус",
  "item.minecraft.piglin_banner_pattern": "шара банера□њушка",
  "block.minecraft.composter": "компостер",
  "block.minecraft.barrel": "буре",
  "block.minecraft.smoker": "пушница",
  "block.minecraft.blast_furnace": "висока пећница",
  "block.minecraft.cartography_table": "сто за картографију",
  "block.minecraft.fletching_table": "стрељашки сто",
  "block.minecraft.grindstone": "млински камен",
  "block.minecraft.lectern": "фењер",
  "block.minecraft.smithing_table": "ковачки сто",
  "block.minecraft.stonecutter": "резач камена",
  "block.minecraft.bell": "звоно",
  "block.minecraft.lantern": "фењер",
  "block.minecraft.soul_lantern": "фењер душа",
  "item.minecraft.sweet_berries": "слатке бобице",
  "block.minecraft.campfire": "логорска ватра",
  "block.minecraft.soul_campfire": "душевна логорска ватра",
  "block.minecraft.shroomlight": "светлопечурка",
  "item.minecraft.honeycomb": "саће",
  "block.minecraft.bee_nest": "пчелино гнездо",
  "block.minecraft.beehive": "кошница",
  "item.minecraft.honey_bottle": "боца меда",
  "block.minecraft.honey_block": "блок меда",
  "block.minecraft.honeycomb_block": "блок саћа",
  "block.minecraft.lodestone": "магнетит",
  "block.minecraft.netherite_block": "блок недерита",
  "block.minecraft.ancient_debris": "древни остаци",
  "block.minecraft.target": "мета",
  "block.minecraft.crying_obsidian": "плачући обсидијан",
  "block.minecraft.blackstone": "црна калдрма",
  "block.minecraft.blackstone_slab": "плоча од црне калдрме",
  "block.minecraft.blackstone_stairs": "степенице од црне калдрме",
  "block.minecraft.gilded_blackstone": "позлаћена црна калдрма",
  "block.minecraft.polished_blackstone": "полирана црна калдрма",
  "block.minecraft.polished_blackstone_slab": "плоча од полиране црне калдрме",
  "block.minecraft.polished_blackstone_stairs": "степенице од полиране црне калдрме",
  "block.minecraft.chiseled_polished_blackstone": "исклесана полирана црна калдрма",
  "block.minecraft.polished_blackstone_bricks": "полиране цигле од црне калдрме",
  "block.minecraft.polished_blackstone_brick_slab": "полирана плоча од цигала црне калдрме",
  "block.minecraft.polished_blackstone_brick_stairs": "полиране степенице од цигала црне калдрме",
  "block.minecraft.cracked_polished_blackstone_bricks": "напукле полиране цигле од црне калдрме",
  "block.minecraft.respawn_anchor": "реинкарнационо сидро",
}
export const sr_sp = items; 
